import { Injectable } from '@angular/core';
import { TxnChannel, ViewTxn } from '@b3networks/api/inbox';
import { Query } from '@datorama/akita';
import { map } from 'rxjs/operators';
import { AppState } from './app-state.model';
import { AppStore } from './app.store';

@Injectable({ providedIn: 'root' })
export class AppQuery extends Query<AppState> {
  // omni
  myWorkV2$ = this.select(state => state.myWorkV2);
  sectionOmni$ = this.select(state => state.sectionOmni);
  latestViewMyWorks$ = this.select(state => state.latestViewMyWorks);
  sidebarTabActive$ = this.select(state => state.sidebarTabActive);
  emailUWState$ = this.select(state => state.emailUWState);
  showRightSidebar$ = this.select(state => state.showRightSidebar);
  mentionCountTeamChat$ = this.select(state => state.mentionCountTeamChat);
  quillEditor$ = this.select(state => state.quillEditor);
  triggerScrollBottomView$ = this.select(state => state.triggerScrollBottomView);
  triggerDoCheckScroll$ = this.select(state => state.triggerDoCheckScroll); // when resize height content msg, should be trigger docheck to update height viewport
  memberMenu$ = this.select('memberMenu');
  isShowPopup$ = this.select(state => state.popupState?.isShowPopup);
  isLoadingTemplate$ = this.select(state => state.popupState?.isLoadingTemplate);
  systemStatusExpiredAt$ = this.select(state => state.popupState?.systemStatusExpiredAt);
  remainTime$ = this.select(state =>
    state.popupState?.systemStatusExpiredAt > 0 ? state.popupState?.remainTime : null
  );
  tag$ = this.select(state => state.popupState?.tag);
  loadingQueryTxn$ = this.select(state => state.loadingQueryTxn);
  initHeightTxn$ = this.select(state => state.initHeightTxn);
  viewTxn$ = this.select(state => state.viewTxn);
  triggerRefreshTxn$ = this.select(state => state.triggerRefreshTxn);
  triggerScrollUpTxn$ = this.select(state => state.triggerScrollUpTxn);
  triggerRefreshQueryTxn$ = this.select(state => state.triggerRefreshQueryTxn);
  triggerRefreshActiveCall$ = this.select(state => state.triggerRefreshActiveCall);
  triggerIsScrollDownTxn$ = this.select(state => state.triggerIsScrollDownTxn);
  customerTxnReports$ = this.select(state => state.customerTxnReports);
  collapseSidebar$ = this.select(state => state.collapseSidebar);
  splitMode$ = this.select(state => state.splitMode);
  isFetchingTxnDetail$ = this.select(state => state.isFetchingTxnDetail);
  isFetchingQueryTxns$ = this.select(state => state.isFetchingQueryTxns);
  isSmallBreakpont$ = this.select(state => state.isSmallBreakpont);
  currentWidthDiscussion$ = this.select(state => state.currentWidthDiscussion);
  isOpenPreviewNoAvailable$ = this.select(state => state.isOpenPreviewNoAvailable);
  isOpenLeftSidebar$ = this.select(state => state.isOpenLeftSidebar);
  isOpenInternalSpace$ = this.select(state => state.isOpenInternalSpace);
  isExpandRightContent$ = this.select(state => state.isExpandRightContent);
  channelsByLicense$ = this.select(state => state.channelsByLicense);
  discoveryChannelState$ = this.select(state => state.discoveryChannelState);
  discoveryNewsfeedState$ = this.select(state => state.discoveryNewsfeedState);
  recommandNewsfeedState$ = this.select(state => state.recommandNewsfeedState);
  osName$ = this.select(state => state.osName);
  pendingTxns$ = this.select(state => state.pendingTxns);
  isFullScreen$ = this.select(state => state.isFullScreen);
  modeViewPost$ = this.select(state => state.modeViewPost);
  hasRobinChat$ = this.select(state => state.hasRobinChat);
  draftMsgRobin$ = this.select(state => state.draftMsgRobin);
  forceWidgetPage$ = this.select(state => state.forceWidgetPage);
  popupHover$ = this.select(state => state.popupHover);
  screenMode$ = this.select(state => state.screenMode);
  triggerCheckResizeWindow$ = this.select(state => state.triggerCheckResizeWindow);
  hasRightSidebar$ = this.select(state => state.hasRightSidebar);
  isOverlayRightSB$ = this.select(state => state.isOverlayRightSB);
  isOverlayLeftSB$ = this.select(state => state.isOverlayLeftSB);
  triggerExpandRightContent$ = this.select(state => state.triggerExpandRightContent);
  triggerExpandLeftSidebar$ = this.select(state => state.triggerExpandLeftSidebar);

  constructor(protected override store: AppStore) {
    super(store);
  }

  selectFilterByViewTxn(viewTxn: ViewTxn) {
    return this.select(entity => entity?.myWorkV2?.[viewTxn]?.txnUuidsFilter);
  }

  getValueStore() {
    return this.getValue();
  }

  countPendingInboxByChannel$(channel: TxnChannel) {
    return this.select(state => state.pendingTxns).pipe(
      map(x => x || []),
      map(l => l.filter(x => x.channel === channel).length)
    );
  }

  getReportByCustomerUuid(customerUuid: string) {
    return this.getValue().report?.[customerUuid];
  }

  selectFilterReportByCustomerUuid(customerUuid: string) {
    return this.select(entity => entity?.report?.[customerUuid]?.txnUuidsFilter);
  }
}
